import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { IDownloadFormObj } from '../components/DownloadReportModal/DownloadReportForm/DownloadReportForm';
import { getReportPresentationLink } from '../services/reports';


export const useDownloadModal = () => {
  const [active, setActive] = useState(false);
  const [inProgress, setInProgress] = useState(false);
  const [downloadFinished, setDownloadFinished] = useState(false);
  const {reportId} = useParams();
  const clickOnLinkAndDownload = async (path: string, fileName: string) => {
    const link = document.createElement('a');
    link.setAttribute('download', fileName);
    link.href = path;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleModalState = (status: boolean) => {
    if(!status){
      setActive(false);
      setDownloadFinished(false);
      return setInProgress(false);
    }
    return setActive(true);
  };

  const makeDownloadHappend = async (data: IDownloadFormObj, customReportId?: string) => {
    try {
      const id = customReportId || reportId || '0';
      const dataFormat = data?.dataFormat;
      const lang = data?.preferredLanguage || 'en';
      setInProgress(true);
      const presentationLink = await getReportPresentationLink(id, lang, dataFormat);
      const fileName = 'presentation.pptx';
      const {downloadUrl} = presentationLink;
      if(downloadUrl){
        await clickOnLinkAndDownload(downloadUrl, fileName);
      }
      setDownloadFinished(true);
      handleModalState(false);
    } catch (e) {
      handleModalState(false);
    }

  };
  return {
    active,
    inProgress,
    downloadFinished,
    makeDownloadHappend,
    handleModalState,
    clickOnLinkAndDownload
  };
};
